import React, { useRef } from 'react';
import { Container, Typography, Grid, Paper, Box, Button } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment/moment';
import { useState, useEffect } from 'react';

const Report = ({ formData, jobTitle, institutions, course, semester, PartyCat, contentRef }) => {

    const [rows, setrows] = useState([]);
    const [JobTitle, setJobTitle] = useState("");
    const [PartyType, setPartyType] = useState("");
    const [Institute, setInstitute] = useState("");
    const [Course, setCourse] = useState("");
    const [Sem, setSem] = useState("");

    useEffect(() => {
        if (formData?.BillType === "C" || formData?.Profession === "C") {
            setJobTitle(() => {

                const foundJob = jobTitle.find(obj => obj.Id === formData.JobTitle);
                if (foundJob) {
                    return foundJob.Name;
                } else {
                    return "N/A";
                }
            });
            setPartyType(() => {

                const foundParty = PartyCat.find(obj => obj.Id === formData.BillToPartyId);
                if (foundParty) {
                    return foundParty.Name;
                } else {
                    return "N/A";
                }
            });
        } else {
            setInstitute(() => {

                const found = institutions.find(obj => obj.Id === formData.InstituteID);
                if (found) {
                    return found.Name;
                } else {
                    return "N/A";
                }
            });
            setCourse(() => {
                const found = course.find(obj => obj.Id === formData.CourseId);
                if (found) {
                    return found.Name;
                } else {
                    return "N/A";
                }
            });
            setSem(() => {
                const found = semester.find(obj => obj.Id === formData.SemesterId);
                if (found) {
                    return found.Name;
                } else {
                    return "N/A";
                }
            });
        }
    }, [formData, jobTitle, institutions, course, semester, PartyCat]);

    return (
        <>
            <div ref={contentRef}>
                <Paper style={styles.page} elevation={3}>
                    <Container maxWidth="md">
                        <Typography variant="h4" gutterBottom align="center">
                            Resident Registration
                        </Typography>

                        <Paper elevation={1} style={styles.section}>
                            <Typography variant="h5" gutterBottom>
                                Personal Info
                            </Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Name:</strong>&nbsp;&nbsp;{formData?.FirstName} &nbsp;{formData?.MidName} &nbsp;{formData.LastName}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body1"><strong>Email:</strong>&nbsp;&nbsp;{formData?.Email}</Typography>
                                </Grid>

                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Mobile:</strong>&nbsp;&nbsp;{formData?.Mobile}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body1"><strong>Gender:</strong>&nbsp;&nbsp;{formData?.Gender}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Typography variant="body1"><strong>Source:</strong>&nbsp;&nbsp;{formData?.Source === 4 ? "Family Friend" : formData.Source === 2 ? "Print Media" : "Social Media"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>DOB:</strong>&nbsp;&nbsp;{moment(formData?.Dob).format("MM-DD-YYYY")} </Typography>
                                </Grid>
                                <Grid item xs={12} sm={7}>
                                    <Typography variant="body1"><strong>Address:</strong>&nbsp;&nbsp;{formData?.PermanentAddr} &nbsp;{formData?.AreaName} - {formData.Pincode} </Typography>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper style={styles.section}>
                            <Typography variant="h5" gutterBottom>
                                Family Info
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={7} sm={12}>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Title</TableCell>
                                                    <TableCell align="left">Name</TableCell>
                                                    <TableCell align="left">Age&nbsp;(g)</TableCell>
                                                    <TableCell align="left">Relation&nbsp;(g)</TableCell>
                                                    <TableCell align="left">Mobile&nbsp;(g)</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {formData?.mstResidentDtlEntities?.map((row) => (
                                                    <TableRow key={row.Mobile} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                        <TableCell component="th" scope="row">{row.RelationTitle}</TableCell>
                                                        <TableCell align="left">{row.RelativeName}</TableCell>
                                                        <TableCell align="left">{row.Age}</TableCell>
                                                        <TableCell align="left">{row.Relation}</TableCell>
                                                        <TableCell align="left">{row.Mobile}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </Paper>

                        <Paper style={styles.section}>
                            <Typography variant="h5" gutterBottom>
                                Work Info
                            </Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Bill Type:</strong>&nbsp;{formData?.BillType === "I" ? "Individual" : "Corporate"}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Typography variant="body1"><strong>Profession:</strong>&nbsp;{formData?.Profession === "S" ? "Student" : "Service"}</Typography>
                                </Grid>
                                {/* {(formData?.BillType === "C" || formData?.Profession === "C") ? (
                                    // Content for BillType or Profession equal to "C"
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={5}>
                                            <Typography variant="body1"><strong>Job Title:</strong>&nbsp;&nbsp; ;{formData?.JobTitle === 1 ? " " :formData?.JobTitle === 4 ? "Accountant" :formData?.JobTitle === 6 ? "Admin" :formData?.JobTitle === 2 ? "Hod":formData?.JobTitle === 5 ? "IT Head":"Warden"  }</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body1"><strong>Billing Corporate:</strong>&nbsp;&nbsp; ;{formData?.BillToPartyId === 46 ? "Student" : "Service"}</Typography>
                                        </Grid>
                                     
                                    </Grid>
                                ) : (
                                    // Content for BillType or Profession not equal to "C"
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={5}>
                                            <Typography variant="body1"><strong>Institute:</strong>&nbsp;&nbsp;MIT Commerce And Science College</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={4}>
                                            <Typography variant="body1"><strong>Course:</strong>&nbsp;&nbsp;Bsc Computer Science</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={3}>
                                            <Typography variant="body1"><strong>Sem:</strong>&nbsp;&nbsp;Second Semester</Typography>
                                        </Grid>
                                    </Grid>
                                )} */}

                                {(formData?.BillType === "C" || formData?.Profession === "C") && (<Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Job Title:</strong>&nbsp;&nbsp;{JobTitle}</Typography>
                                </Grid>
                                )}
                                {(formData?.BillType === "C" || formData?.Profession === "C") && (<Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Billing Corporate:</strong>&nbsp;&nbsp;{PartyType} </Typography>
                                </Grid>
                                )}

                                {(formData?.Profession === "S") && (<Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Institute:</strong>&nbsp;&nbsp;{Institute}</Typography>
                                </Grid>)}
                                {(formData?.Profession === "S") && (<Grid item xs={12} sm={4}>
                                    <Typography variant="body1"><strong>Course:</strong>&nbsp;&nbsp;{Course}</Typography>
                                </Grid>)}
                                {(formData?.Profession === "S") && (<Grid item xs={12} sm={3}>
                                    <Typography variant="body1"><strong>Semester:</strong>&nbsp;&nbsp;{Sem}</Typography>
                                </Grid>)}

                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong> Email:</strong>&nbsp;&nbsp;{formData?.WorkEmail}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography variant="body1"><strong> Phone:</strong>&nbsp;&nbsp;{formData?.WorkPhone}</Typography>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <Typography variant="body1"><strong>Last Hostel:</strong>&nbsp;&nbsp;{formData?.LastHostle}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                        <Paper style={styles.section}>
                            <Typography variant="h5" gutterBottom>
                                Document Uploaded
                            </Typography>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={5}>
                                    <Typography variant="body1"><strong>Document Type:</strong>&nbsp;{formData?.DocTypeName}</Typography>
                                </Grid>
                            </Grid>
                        </Paper>
                    </Container>
                    <div style={{ marginTop: '30px', fontSize: '14px', textAlign: 'center', color: '#666' }}>
                        <p style={{ marginBottom: '4px' }}>Thank you for choosing Clanbridge Living Pvt Ltd</p>
                        <p>For any queries, please contact: support@clanbridgeliving.in</p>
                    </div>
                </Paper>
            </div>
        </>
    );
};

const styles = {
    page: {
        width: '210mm',
        height: '200mm',
        padding: '2mm',
        backgroundColor: 'white',
        margin: '10px auto',
        boxSizing: 'border-box',
    },
    section: {
        padding: '10px',
        marginBottom: '10px',
        backgroundColor: 'white',
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
    },
};

export default Report;
